/**
 * The page's data — written by the server into
 * `<script type="application/json" id="dith-data">` (templates/site/base.html.twig).
 *
 * Since the markup is the server's (ADR-0003), the block only carries what a
 * module still needs to move or to answer: each entry is named after the
 * module that reads it.
 *
 * @module lib/page-data
 */

/** @type {Record<string, any> | null} */
let data = null;

/** @returns {Record<string, any>} The whole block, parsed once. */
export function pageData() {
    if (!data) {
        const block = document.getElementById('dith-data');
        data = block ? JSON.parse(block.textContent || '{}') : {};
    }

    return data;
}

/**
 * One module's entry.
 *
 * @param {string} name - The module, e.g. "contact/console".
 * @returns {Record<string, any>}
 */
export function pageEntry(name) {
    return pageData()[name] ?? {};
}
